import request from '@/utils/request'

export function UserLogin(UserName, PassWord) {
  return request({
    url: '/v1/UserLogin',
    method: 'post',
    data: {
      username: UserName,
      password: PassWord
    }
  })
}

export function UserLogout() {
  return request({
    url: 'v1/Logout',
    method: 'post'
  })
}

export function GetSelDateList(SelDate) {
  return request({
    url: '/v1/GetSelDateList',
    method: 'post',
    data: {
      seldate: SelDate
    }
  })
}

export function BookSubmit(BookMod) {
  return request({
    url: '/v1/Book',
    method: 'post',
    data: {
      BookMod: BookMod
    }
  })
}

export function CanBook(SelMod) {
  return request({
    url: '/v1/CanBook',
    method: 'post',
    data: {
      SelMod: SelMod
    }
  })
}

export function GetWaitList() {
  return request({
    url: '/v1/WaitVerifyList',
    method: 'post'
  })
}

export function Verify(SelId, Type, Mark) {
  return request({
    url: '/v1/Verify',
    method: 'post',
    data: {
      id: SelId,
      type: Type,
      mark: Mark
    }
  })
}

export function GetWxUserInfo(Code) {
  return request({
    url: '/v1/GetUserInfo',
    method: 'post',
    data: {
      code: Code
    }
  })
}

export function WxUserLogout() {
  return request({
    url: '/v1/WxLogout',
    method: 'post'
  })
}

export function GetUserCanOpen(WxUserId) {
  return request({
    url: '/v1/GetUserCanOpen',
    method: 'post',
    data: {
      wxuserid: WxUserId
    }
  })
}

export function OnlineBook(Id, UserName, Mobile, Componey, WxUserId, UserNo) {
  return request({
    url: '/v1/OnlineBook',
    method: 'post',
    data: {
      id: Id,
      username: UserName,
      mobile: Mobile,
      componey: Componey,
      wxuserid: WxUserId,
      userno: UserNo
    }
  })
}

export function GetOnlineAppList(PageIndex, PageSize) {
  return request({
    url: '/v1/GetOnlineAppList',
    method: 'post',
    data: {
      pageindex: PageIndex,
      pagesize: PageSize
    }
  })
}

export function GetOnlineVeredList(PageIndex, PageSize) {
  return request({
    url: '/v1/GetOnlineVeredList',
    method: 'post',
    data: {
      pageindex: PageIndex,
      pagesize: PageSize
    }
  })
}

export function OnlineVerify(Id, VerType, Mark) {
  return request({
    url: '/v1/OnlineVerify',
    method: 'post',
    data: {
      id: Id,
      type: VerType,
      mark: Mark
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/all.js